import { Checkbox } from 'antd';
import React, { useState } from 'react';

import { Button, Modal } from '@/components';
import { TextAreaAntd } from '@/components/text-area';
import { useTranslation } from 'react-i18next';

import styles from './Modals.module.css';

const CheckboxGroup = Checkbox.Group;

interface DeclineModalProps {
  onDecline: (reason?: string) => void;
  onCancel: () => void;
  isLoading: boolean;
}

function DeclineModal({ onDecline, onCancel, isLoading }: DeclineModalProps) {
  const [checkedList, setCheckedList] = useState<string[]>([]);
  const [reason, setReason] = useState<string>('');
  const { t } = useTranslation();
  const onChange = (list: string[]) => {
    setCheckedList(list);
  };

  const handleDecline = () => {
    if (reason && !!checkedList.length) {
      const combinedReason = [reason, ...checkedList].join(' | ');
      onDecline(combinedReason);
    } else if (reason) {
      onDecline(reason);
    } else if (checkedList.length > 0) {
      const combinedReason = checkedList.join(' | ');
      onDecline(combinedReason);
    } else {
      onDecline();
    }
  };

  const reasonOptions = [
    t('inviteView.declineModal.reason1'),
    t('inviteView.declineModal.reason2'),
    t('inviteView.declineModal.reason3'),
    t('inviteView.declineModal.reason4'),
    t('inviteView.declineModal.reason5')
  ];

  return (
    <Modal closeButton={false} modalStyles={{ maxWidth: '480px' }}>
      <div className={styles.welcomeModal}>
        <h2 className={`${styles.welcomeModalTitle} ${styles.BottomMarginSm}`}>
          {t('inviteView.declineModal.title')}
        </h2>
        <div className={styles.welcomeModalDescription}>
          {t('inviteView.declineModal.description')}
        </div>
        <div className={styles.welcomeModalBody}>
          <CheckboxGroup
            options={reasonOptions}
            value={checkedList}
            onChange={onChange}
            className={styles.declineModalCheckboxes}
          />
          <TextAreaAntd
            label={t('inviteView.declineModal.label')}
            autoSize={{ minRows: 4, maxRows: 5 }}
            placeholder={t('inviteView.declineModal.placeholder')}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        <div className={styles.welcomeModalButton}>
          <Button theme="cta" onClick={handleDecline} isLoading={isLoading}>
            {t('inviteView.declineModal.declineButton')}
          </Button>
          <Button onClick={onCancel} className={styles.cancelButton}>
            {t('inviteView.declineModal.cancelButton')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DeclineModal;
